/**
 * Environment Configuration
 * This file reads configuration from .env file
 */

/**
 * Get environment configuration from .env variables
 */
export const environment = {
  // Read from .env: REACT_APP_ENVIRONMENT (defaults to "LOCAL")
  takeDataFrom: process.env.REACT_APP_ENVIRONMENT || 'LOCAL',

  // Determine API URL based on environment
  apiUrl: process.env.REACT_APP_ENVIRONMENT === 'VPS'
    ? process.env.REACT_APP_API_URL_VPS || 'https://api.foodallergycard-app.com/api'
    : process.env.REACT_APP_API_URL_LOCAL || 'http://localhost:3000/api',

  // Determine Files URL based on environment
  filesUrl: process.env.REACT_APP_ENVIRONMENT === 'VPS'
    ? process.env.REACT_APP_FILES_URL_VPS || 'https://api.foodallergycard-app.com/files'
    : process.env.REACT_APP_FILES_URL_LOCAL || 'http://localhost:3000/files',

  // Determine Assets URL based on environment
  assetsUrl: process.env.REACT_APP_ENVIRONMENT === 'VPS'
    ? process.env.REACT_APP_ASSETS_URL_VPS || "/assets"
    : process.env.REACT_APP_ASSETS_URL_LOCAL || 'http://localhost:3000/assets',

  // Asset version for cache-busting
  // IMPORTANT: Update REACT_APP_ASSET_VERSION in .env on every deployment
  assetVersion: process.env.REACT_APP_ASSET_VERSION || '2',
};

/**
 * Add cache-busting version parameter to a URL
 * Use this for all JSON fetches to ensure fresh data on mobile devices
 *
 * @param {string} url - The URL to add cache-busting to
 * @returns {string} URL with version query parameter
 */
export const withCacheBust = (url) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${environment.assetVersion}`;
};

/**
 * Log current asset version for debugging
 * Call this on app initialization to verify version in network requests
 */
export const logAssetVersion = () => {
  console.log(`📦 [Environment] Asset Version: ${environment.assetVersion}`);
  console.log(`   Environment: ${environment.takeDataFrom}`);
  console.log(`   Assets URL: ${environment.assetsUrl}`);
};
